import React, { FC } from 'react';

import { RewardTierBaseProps } from '../reward-tier/types';

import {
  Container,
  InformationContainer,
  RewardsWrapper,
  TierLabel,
  Title,
  TitleWrapper,
} from './reward-tier-no-input.styled';

export const RewardTierNoInput: FC<RewardTierBaseProps> = ({
  children,
  name = '',
  tierLabel,
  titleId,
}) => {
  return (
    <Container>
      <InformationContainer>
        <TitleWrapper>
          <Title id={titleId}>{name}</Title>
        </TitleWrapper>
        <RewardsWrapper>
          <TierLabel>{tierLabel} Points</TierLabel>
        </RewardsWrapper>
      </InformationContainer>
      {children}
    </Container>
  );
};
